import React, { useEffect, useState } from 'react';
import { Clock3Icon, EyeIcon, SparklesIcon } from 'lucide-react';
interface OfferTime {
  day: string;
  hours: string;
  minutes: string;
  seconds: string;
}
function getOfferTime(): OfferTime {
  const now = new Date();
  const tomorrow = new Date(now);
  tomorrow.setHours(24, 0, 0, 0);
  const remaining = Math.max(0, tomorrow.getTime() - now.getTime());
  const totalSeconds = Math.floor(remaining / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  return {
    day: new Intl.DateTimeFormat('en-US', {
      weekday: 'long'
    }).format(now).toUpperCase(),
    hours: String(hours).padStart(2, '0'),
    minutes: String(minutes).padStart(2, '0'),
    seconds: String(seconds).padStart(2, '0')
  };
}
export function TodayOfferCard() {
  const [offerTime, setOfferTime] = useState<OfferTime>(getOfferTime);
  useEffect(() => {
    const timer = window.setInterval(() => setOfferTime(getOfferTime()), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return <aside aria-label="Information about today's available offer" className="mt-4 overflow-hidden rounded-2xl border border-[#C9AA62]/80 bg-slate px-4 py-4 text-white shadow-[0_14px_30px_-18px_rgba(61,61,61,0.8)] ring-1 ring-[#C9AA62]/15 sm:px-5 sm:py-4" data-id="element-216" data-mp="e8jn5toohelx">
      <div className="flex flex-col items-center gap-3 text-center sm:flex-row sm:justify-between sm:gap-5 sm:text-left" data-id="element-217" data-mp="n6lueqz093hn">
        <div className="min-w-0" data-id="element-218" data-mp="3rmwscgozmfz1">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-[#C9AA62]/50 bg-[#C9AA62]/10 px-2.5 py-1 text-[11px] font-bold tracking-[0.12em] text-[#F5DEA0]" data-id="element-219" data-mp="3rny2miy6iyfp">
            <SparklesIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-220" data-mp="4howmd4efsuo" />
            TODAY'S OFFER ONLY
          </span>
          <p className="mt-2 text-xs font-medium uppercase tracking-[0.18em] text-white/65" data-id="element-221" data-mp="3cwfo6pkyxbyg">
            {offerTime.day}
          </p>
          <p className="mt-1 text-sm leading-snug text-white/85" data-id="element-222" data-mp="37wtcikksg3rr">This promotion closes at midnight your local time.</p>
        </div>

        <div className="flex shrink-0 items-center gap-3" role="timer" aria-live="polite" data-id="element-223" data-mp="1gu2i7rxqrd0z">
          <Clock3Icon className="hidden h-5 w-5 text-[#F5DEA0] sm:block" aria-hidden="true" data-id="element-224" data-mp="1llkiedrxx9kw" />
          <TimeUnit value={offerTime.hours} label="HRS" data-id="element-225" data-mp="1qk5lqm2ho9dk" />
          <span className="pb-4 font-serif-display text-2xl font-bold text-[#F5DEA0]" aria-hidden="true" data-id="element-226" data-mp="1qjm3t5cu9kzj">:</span>
          <TimeUnit value={offerTime.minutes} label="MIN" data-id="element-227" data-mp="syrke35xqoel" />
          <span className="pb-4 font-serif-display text-2xl font-bold text-[#F5DEA0]" aria-hidden="true" data-id="element-228" data-mp="xwt32mzg8lpj">:</span>
          <TimeUnit value={offerTime.seconds} label="SEC" data-id="element-229" data-mp="12t9o38bcqjye" />
        </div>
      </div>

      <div className="mt-3 flex items-center justify-center gap-2 border-t border-white/10 pt-3 text-center text-xs text-white/65 sm:justify-start" data-id="element-230" data-mp="16xhhvjwo2q3h">
        <EyeIcon className="h-3.5 w-3.5 shrink-0 text-[#F5DEA0]" aria-hidden="true" data-id="element-231" data-mp="2eccgxhwhaabe" />
        <span data-id="element-232" data-mp="2ido6jnfcqvjl">Review today’s offer before it expires.</span>
      </div>
    </aside>;
}
interface TimeUnitProps {
  value: string;
  label: string;
}
function TimeUnit({
  value,
  label
}: TimeUnitProps) {
  return <div className="flex min-w-[38px] flex-col items-center" data-id="element-233" data-mp="2p0k8aw5q46t">
      <span className="font-serif-display text-3xl font-bold leading-none text-[#F5DEA0] sm:text-4xl" data-id="element-234" data-mp="3tzr45z9m8sup">{value}</span>
      <span className="mt-1 text-[10px] font-semibold tracking-[0.13em] text-white/55" data-id="element-235" data-mp="3p1z2wen2zudu">{label}</span>
    </div>;
}